module.exports = __webpack_public_path__ + "static/dcom3-300x249-7bb839c7a77cac2993c3128b938a5097.png";